import {
    GET_PACKAGES,
    GET_QUESTIONNAIRE_CATEGORIES,
    GET_QUESTIONNAIRE_SUBCATEGORIES,
    GET_CURRENT_SCM_QUESTIONNARE_SUMMARY_DATA,
    GET_CATEGORY_COMPLETION_FOR_USER,
    GET_CURRENT_VENDOR_INFO,
    GET_SECONDARY_SCM_QUESTIONNARY_SUMMARY_DATA,
    QUESTIONNAIRE_LIST_LOADED,
    SET_CURRENT_QUESTIONNAIRE,
    SET_CURRENT_VENDOR,
    QUESTIONNAIRE_SUMMARY_LOADED_ALL_VENDORS,
    CATEGORY_SUMMARY_LOADED_VENDOR,
    QUESTIONNIARE_SUMMARIES_LOADED_VENDOR,
    VENDOR_INFO_LOADED,
    SUPPLY_CHAIN_CATEGORY_SUMMARY_LOADED,
    SUPPLY_CHAIN_CATEGORY_QUESTIONS_LOADED,
    SET_CURRRENT_SUPPLY_CHAIN_CATEGORY,
    SET_REPORT_MANAGEMENT_SUMMARY_TYPE,
} from './types';

const INTIAL_STATE = {
    packages: [{}],
    questionnaireCategories: [{}],
    questionnaireSubCategories: [{}],
    _currentQuestionnaire: '',
    questionnaireSummaryAllVendors: [
        {
            questionnaire_id: '',
            company_id: '',
            questionnaire_name: '',
            company_type: '',
            company_name: '',
            total_count: 0,
            total_answered: 0,
            total_correct: 0,
        },
    ],
    seconaryQuestionnaireSummaryAllVendors: [{}],
    categorySummaryCurrentQuestionnaire: [{}],
    _currentVendor: '',
    currentVendorInfo: {},
    _questionnaireList: [],
    _questionnaireSummariesVendor: [{}],
    _categorySummaryVendor: [{}],
    _vendorInfo: {},
    _supplyChainCategorySummary: [{}],
    _supplyChainCategoryQuestions: [],
    _supplyChainCategory: '',
    _reportManagementSummaryType: 'categorySummary',
};

export default (state = INTIAL_STATE, action) => {
    switch (action.type) {
        // Setters
        case SET_CURRENT_QUESTIONNAIRE:
            return { ...state, _currentQuestionnaire: action.payload };
        case SET_CURRENT_VENDOR:
            return { ...state, _currentVendor: action.payload };
        case SET_CURRRENT_SUPPLY_CHAIN_CATEGORY:
            return { ...state, _supplyChainCategory: action.payload };
        case SET_REPORT_MANAGEMENT_SUMMARY_TYPE:
            return { ...state, _reportManagementSummaryType: action.payload };

        // Api calls
        case QUESTIONNAIRE_LIST_LOADED:
            return { ...state, _questionnaireList: action.payload };
        case QUESTIONNAIRE_SUMMARY_LOADED_ALL_VENDORS:
            return {
                ...state,
                _questionnaireSummaryAllVendors: action.payload,
            };
        case QUESTIONNIARE_SUMMARIES_LOADED_VENDOR:
            return {
                ...state,
                _questionnaireSummariesVendor: action.payload,
            };
        case CATEGORY_SUMMARY_LOADED_VENDOR:
            return { ...state, _categorySummaryVendor: action.payload };
        case VENDOR_INFO_LOADED:
            return { ...state, _vendorInfo: action.payload };
        case SUPPLY_CHAIN_CATEGORY_SUMMARY_LOADED:
            return { ...state, _supplyChainCategorySummary: action.payload };
        case SUPPLY_CHAIN_CATEGORY_QUESTIONS_LOADED:
            return { ...state, _supplyChainCategoryQuestions: action.payload };

        // Packages
        case GET_PACKAGES:
            return { ...state, packages: action.payload };
        case GET_QUESTIONNAIRE_SUBCATEGORIES:
            return { ...state, questionnaireSubcategories: action.payload };

        // Legacy naming scheme
        case GET_QUESTIONNAIRE_CATEGORIES:
            return {
                ...state,
                questionnaireCategories: action.payload,
            };
        case GET_CURRENT_SCM_QUESTIONNARE_SUMMARY_DATA:
            return { ...state, questionnaireSummaryAllVendors: action.payload };
        case GET_CATEGORY_COMPLETION_FOR_USER:
            return {
                ...state,
                categorySummaryCurrentQuestionnaire: action.payload,
            };

        case GET_CURRENT_VENDOR_INFO:
            return { ...state, currentVendorInfo: action.payload };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux/vendor/reducers.js